<template>
	<div class="menu-container">
		<div v-if="!isMobile" class="navbar-white">
			<Navbar
				class="desktop-center"
				:logoSrc="$logoSrc"
				:backButton="false"
			/>
		</div>
		<div class="navbar-page menu-page-container">
			<div
				class="menu-page sk-scrollbar"
				ref="menuPage"
				@scroll.passive="handleMenuScroll"
			>
				<div v-if="isMobile" class="navbar-white">
					<Navbar
						class="desktop-center"
						:logoSrc="$logoSrc"
						:backButton="false"
					/>
				</div>
				<Banner />
				<div v-if="!loading" class="menu-page-content">
					<OfflineWidgetAlt v-if="showOffline" />
					<ComingSoonSection v-if="showComingSoon" />
					<slot v-if="showMenu">
						<HorizontalNavbar
							ref="menuHeader"
							class="desktop-center menu-header"
							:isSticky="headerSticky"
							:stickyEnabled="headerSticky"
							:options="menuTabs"
							:stickyOffset="0"
							@optionSelected="tabClicked"
						/>
						<MenuCategoryNavbar
							ref="menuCategoryNavbar"
							:categorizedMenu="categorizedMenu"
							:stickyEnabled="headerSticky"
							@scrollToSelectedCategory="scrollToSelectedCategory"
						/>
						<LateNightBanner />
						<PopupBanner />
						<BackupBanner />
						<CategorizedMenu
							ref="categorizedMenuRef"
							:categorizedMenu="categorizedMenu"
						/>
					</slot>
				</div>
				<div v-if="showMenu">
					<Footer
						@openCartSummary="openCartSummary"
						:showDeliveryBar="true"
					/>
				</div>
			</div>
			<FloatingCartSummary ref="cartSummary" :showDeliveryBar="true" />
		</div>
		<ItemModal ref="itemModal" />
	</div>
</template>

<script>
import { eventBus } from "@/eventBus"
import { EventBusEvents } from "@/enums/EventBusEvents"
import menuMixin from "@/mixins/menu-mixin"
import menuCategoriesMixin from "@/mixins/menu-categories-mixin"
import mobileResponsivenessMixin from "@/mixins/mobile-responsiveness-mixin"
import Navbar from "@/components/navbars/Navbar.vue"
import Banner from "@/components/Banner.vue"
import MenuItem from "@/components/menu/MenuItem.vue"
import Footer from "@/components/Footer.vue"
import ComingSoonSection from "@/components/menu/ComingSoonSection.vue"
import OfflineWidgetAlt from "@/components/menu/OfflineWidgetAlt.vue"
import FloatingCartSummary from "@/components/common/FloatingCartSummary.vue"
import LateNightBanner from "@/components/menu/LateNightBanner.vue"
import PopupBanner from "@/components/menu/PopupBanner.vue"
import BackupBanner from "@/components/menu/BackupBanner.vue"
import HorizontalNavbar from "@/components/common/HorizontalNavbar.vue"
import MenuCategoryNavbar from "@/components/menu/MenuCategoryNavbar.vue"
import CategorizedMenu from "@/components/menu/CategorizedMenu.vue"
import ItemModal from "@/components/modals/ItemModal.vue"

export default {
	name: "DefaultMenu",
	mixins: [menuMixin, menuCategoriesMixin, mobileResponsivenessMixin],
	components: {
		Banner,
		MenuItem,
		Navbar,
		Footer,
		MenuCategoryNavbar,
		CategorizedMenu,
		ItemModal,
		ComingSoonSection,
		OfflineWidgetAlt,
		FloatingCartSummary,
		LateNightBanner,
		PopupBanner,
		BackupBanner,
		HorizontalNavbar
	},
	data: function () {
		return {
			categoriesScrollToOffset: -100,
			headerSticky: false
		}
	},
	created: function () {
		if (
			this.$route.params.table != undefined ||
			this.$store.getters.table != -1
		) {
			if (this.$route.params.table != undefined) {
				this.$store.dispatch(
					"setCurrentTable",
					this.$route.params.table
				)
			} else if (this.$route.params.table == 0) {
				this.$store.dispatch("setCurrentTable", -1)
			}
		} else {
			this.$store.dispatch("setCurrentTable", -1)
		}
	},
	mounted: function () {
		this.trackOutOfStock()
		this.trackComingSoon()
		this.openPreorderOnlyModalIfNeeded()
	},
	methods: {
		handleMenuScroll() {
			const menuHeader = this.$refs.menuHeader

			if (menuHeader && menuHeader.$el) {
				const rect = menuHeader.$el.getBoundingClientRect()
				const threshold = this.isMobile ? 0 : 75
				this.headerSticky = rect.top <= threshold + 5
			}

			if (
				this.$refs.categorizedMenuRef &&
				this.$refs.categorizedMenuRef.$refs
			) {
				this.calculateCategoryWhenScrolling(
					this.$refs.menuCategoryNavbar,
					this.$refs.categorizedMenuRef.$refs["category-section"]
				)
			}
		},
		startPreorder() {
			eventBus.emit(EventBusEvents.OPEN_MENU_TIME_MODAL, {
				date: this.$store.state.deliveryDate
			})
		},
		openCartSummary() {
			this.$refs.cartSummary.open()
		}
	},
	computed: {
		categorizedMenuRefKey() {
			return "categorizedMenuRef"
		}
	}
}
</script>

<style scoped>
.menu-section-title {
	margin: 5px auto !important;
	padding-left: 10px;
}

.menu-page {
	padding-left: 0;
	padding-right: 0;
	overflow-x: hidden;
}

.button {
	max-width: 186px;
}
</style>

